import { render } from "./NavbarItem.vue?vue&type=template&id=27e9202a"
import script from "./NavbarItem.vue?vue&type=script&lang=js"
export * from "./NavbarItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__